import React from "react";
import { motion } from "framer-motion";
import { Hexagon, TrendingUp } from "lucide-react";

const LeagueCard = ({ name, icon, matches }) => {
  return (
    <motion.div
      className="bg-gray-800 rounded-lg p-2 flex flex-col items-center"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="flex items-center justify-center w-8 h-8 bg-gray-700 rounded-full mb-1">
        {/* Mostrar el emoji como ícono si es bandera o copa */}
        {icon === "🏆" ||
        icon.startsWith("🇪") ||
        icon.startsWith("🇮") ||
        icon.startsWith("🏴") ? (
          <span className="text-lg">{icon}</span>
        ) : (
          // Icono por defecto si no es reconocible
          <TrendingUp className="w-4 h-4 text-white" />
        )}
      </div>
      <span className="text-white text-xs text-center line-clamp-1">
        {name}
      </span>
      <span className="text-gray-400 text-xs">{matches}</span>
    </motion.div>
  );
};

export default LeagueCard;
